import { render, staticRenderFns } from "./chatRecordDetail.vue?vue&type=template&id=6f533530"
import script from "./chatRecordDetail.vue?vue&type=script&lang=js"
export * from "./chatRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./chatRecordDetail.vue?vue&type=style&index=0&id=6f533530&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports